export const formateTimeStamp = (ts) => {
    return ts.slice(0,10)
}